function r(t) {
  var n;
  return t == null || Array.isArray(t) && (t == null ? void 0 : t.length) < 1 || typeof t == "object" && ((n = Object.keys(t)) == null ? void 0 : n.length) < 1 || t === "";
}
export {
  r as default
};
